import {
    Button,
    Card,
    Dropdown,
    DropdownContent,
    DropdownItem,
    DropdownTrigger,
    FilterButton,
    SearchInput,
    Switch,
} from "@jhool-io/fe-components";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { CalenderEvents } from "../../../types/schedule.types";
import moment from "../../../../../utils/moment";

import {
    makeStringFirstLetterCapital,
    removeEnumUnderscore,
    truncateString,
} from "../../../../../utils/helpers";
import DashboardCaseloadView from "../CaseloadView/CaseloadView";
import ScheduleWeekView from "../ScheduleWeekView/ScheduleWeekView";
import ScheduleDayView from "../../ScheduleDayView/ScheduleDayView";
import ChevronLeftIcon from "../../../../../icons/ChevronLeft";
import ChevronRightIcon from "../../../../../icons/ChevronRight";

export default function CaseloadViewWrapper({
    schedules,
}: {
    schedules: CalenderEvents[];
}) {
    const [searchParams, setSearchParams] = useSearchParams();

    const clientFilter = searchParams.get("search_string") || "";

    const filter = searchParams.get("filter");

    const currentView = searchParams.get("view") || "caseload";

    const todayDate = moment().format("Do, MMM");

    const handleCurrentView = (view: string) => {
        searchParams.set("view", view);
        setSearchParams(searchParams);
    };

    const handleSetSearchString = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value === "") searchParams.delete("search_string");
        else searchParams.set("search_string", e.target.value);

        setSearchParams(searchParams);
    };

    const handleSetFilter = (filterType: string) => {
        if (filterType === "") searchParams.delete("filter");
        else searchParams.set("filter", filterType);

        setSearchParams(searchParams);
    };

    return (
        <div>
            <div className="flex flex-col gap-y-2 mb-[--spacing-header]">
                <h3 className="text-title font-extrabold">
                    Manage all your activities
                </h3>
                <p className="text-base font-normal">
                    You can manage your availability, reserve time and time-off
                    here on mantle
                </p>
            </div>
            <Card>
                <div className="[border-bottom:1px_solid_var(--color-stroke)] px-1 flex items-center gap-[-spacing-items] flex-wrap justify-between overflow-x-auto pb-[--padding-card-y]">
                    <SearchInput
                        placeholder="Search by client name or chart number"
                        containerClass="w-[300px]"
                        defaultValue={clientFilter}
                        onChange={handleSetSearchString}
                    />
                    <div className="flex items-center flex-wrap gap-[--spacing-items]">
                        <Dropdown>
                            <DropdownTrigger asChild>
                                <FilterButton>
                                    {filter
                                        ? makeStringFirstLetterCapital(
                                              truncateString(
                                                  removeEnumUnderscore(filter)
                                              )
                                          )
                                        : "Show All Clients"}
                                </FilterButton>
                            </DropdownTrigger>
                            <DropdownContent width="auto" align="end">
                                <DropdownItem
                                    onClick={() => handleSetFilter("")}
                                    isSelected={!filter}
                                >
                                    All clients
                                </DropdownItem>
                                <DropdownItem
                                    onClick={() =>
                                        handleSetFilter(
                                            "clients_with_pending_task"
                                        )
                                    }
                                    isSelected={
                                        filter === "clients_with_pending_task"
                                    }
                                >
                                    Clients with pending tasks
                                </DropdownItem>
                            </DropdownContent>
                        </Dropdown>

                        {currentView !== "caseload" && (
                            <div className="flex items-center gap-x-[--spacing-items] text-base font-medium">
                                <Button
                                    size="auto"
                                    variant="can-hover"
                                    className="rounded-full [border:1px_solid_var(--color-stroke)] size-7 p-0"
                                >
                                    <ChevronLeftIcon className="stroke-text" />
                                </Button>

                                <span>{`Today ${todayDate}`}</span>
                                <Button
                                    variant="can-hover"
                                    size="auto"
                                    className="rounded-full [border:1px_solid_var(--color-stroke)] size-7 p-0"
                                >
                                    <ChevronRightIcon className="stroke-text" />
                                </Button>
                            </div>
                        )}

                        <Switch
                            activeSwitch={currentView}
                            switchOptions={[
                                {
                                    title: "My Day",
                                    key: "my_day",
                                    onClick: () => handleCurrentView("my_day"),
                                    disabled: true,
                                },
                                {
                                    title: "My Week",
                                    key: "my_week",
                                    onClick: () => handleCurrentView("my_week"),
                                    disabled: true,
                                },
                                {
                                    title: "Caseload",
                                    key: "caseload",
                                    onClick: () =>
                                        handleCurrentView("caseload"),
                                },
                            ]}
                        />
                    </div>
                </div>
                <div className="overflow-x-auto ">
                    <div className="px-32">
                        {currentView === "my_day" && (
                            <ScheduleDayView schedules={schedules} />
                        )}
                    </div>
                    {currentView === "my_week" && (
                        <div className="pl-[29px] pr-[34px]">
                            <ScheduleWeekView />
                        </div>
                    )}
                    {/* pl-[64px] pr-[34px] */}
                    {currentView === "caseload" && (
                        <div className="min-w-[1000px] max-w-full">
                            <DashboardCaseloadView />
                        </div>
                    )}
                </div>
            </Card>
        </div>
    );
}
